import { Link } from 'react-router-dom';

const highlights = [
  {
    icon: 'ri-chat-3-line',
    title: '分享帖',
    desc: '每天汇总站内最值得看的爆料帖，一条不落。',
  },
  {
    icon: 'ri-wechat-line',
    title: '分享群',
    desc: '微信群与 QQ 群同步开放，进群就能一起讨论。',
  },
  {
    icon: 'ri-links-line',
    title: '分享链接',
    desc: '每周更新专题合集链接，整理清晰、随取随用。',
  },
  {
    icon: 'ri-qr-code-line',
    title: '分享码',
    desc: '限时专题与专属活动的邀请码，每日限量发放。',
  },
];

export default function CommunityTeaser() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gathering%20scene%20with%20floating%20coral%20and%20amber%20paper%20notes%2C%20soft%20gradient%20background%2C%20stylized%20community%20illustration%20style%2C%20clean%20and%20modern%2C%20no%20text&width=1800&height=900&seq=baogua-community-teaser&orientation=landscape"
          alt="爆瓜福利分享社区"
          title="爆瓜福利分享群与分享码"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 to-foreground-950/65"></div>
      </div>

      <div className="relative mx-auto grid w-full max-w-6xl gap-10 px-4 py-16 md:grid-cols-2 md:px-6 md:py-20">
        <div>
          <span className="text-xs font-medium tracking-[0.25em] text-secondary-300">COMMUNITY</span>
          <h2 className="mt-3 font-heading text-2xl font-bold leading-tight text-background-50 md:text-4xl md:leading-tight">
            一个人吃瓜不过瘾
            <br />
            进社区一起聊
          </h2>
          <p className="mt-5 max-w-md text-sm leading-7 text-background-100/85">
            分享帖、分享群、分享链接与分享码，我们把社区入口和资源都整理在同一个页面，加入后即可获取每日更新的吃瓜合集。
          </p>
          <Link
            to="/community"
            className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            前往分享社区
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          {highlights.map((item) => (
            <div key={item.title} className="rounded-lg border border-background-50/15 bg-background-50/10 p-5 backdrop-blur">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-500 text-background-50">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-background-50">{item.title}</h3>
              <p className="mt-2 text-xs leading-6 text-background-100/80">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}